var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8","lg":"6"}},[_c('SalesFunnel',{attrs:{"items":_vm.sf_items}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }